module.exports = "<!DOCTYPE html>\r\n<ion-app>\r\n    <app-sidemenu></app-sidemenu>\r\n</ion-app>"